export default __webpack_public_path__ + "static/media/Mark-6-Suit-11.775bfbcb.jpg";